interface WarningHeader {
  title: string;
  info: string;
  icon: React.ReactNode;
  button: React.ReactNode;
  children?: React.ReactNode;
}
export const WarningHeader = (props: WarningHeader) => {
  return (
    <div className="mt-10 flex border-l-2 border-secondary-100 pl-5 md:gap-12 md:border-none xl:flex xl:flex-row xl:items-center xl:gap-8 xl:pl-20">
      <div className="hidden self-center md:block">{props.icon}</div>

      <div className="flex-col items-center xl:flex xl:flex-row xl:gap-[75px]">
        <div className="mb-4 xl:mb-0">
          <h2 className="mb-6 text-left text-secondary-100 md:mb-2">
            {props.title}
          </h2>
          <p className="text-left leading-snug">{props.info}</p>
          {props.children}
        </div>
        <div>{props.button}</div>
      </div>
    </div>
  );
};
